export const HTTP_METHOD = process.env.REACT_APP_HTTP_METHOD || 'https://'
export const HTTP_URL = process.env.REACT_APP_HTTP_URL || 'resumex.gatewaydigital.ai:'
export const HTTP_PORT = process.env.REACT_APP_HTTP_PORT || ''

// // avinash
// export const HTTP_METHOD = 'http://';
// export const HTTP_URL = '10.0.1.1:'
// export const HTTP_PORT = '8000';

// // production
// export const HTTP_METHOD = 'https://'
// export const HTTP_URL = 'resumex.gatewaydigital.ai:'
// export const HTTP_PORT = ''

// // server
// export const HTTP_METHOD = 'http://';
// export const HTTP_URL = '10.0.0.97:'
// export const HTTP_PORT = '9000';

export const ENCRYPT_LOCAL_STORAGE = false;
export const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
export const ENCRYPTION_IV = process.env.REACT_APP_ENCRYPTION_IV;
export const GNN_API_URL = "https://gnn.thegatewaycorp.com/ResumeX/api"

// Notification Types for filter chips (excluding ALL which is a filter option, not a type)
export const NOTIFICATION_TYPES = [
  { type: 'TASK_ASSIGNED', label: 'Task Assigned' },
  { type: 'TASK_DUE_SOON', label: 'Task Due Soon' },
  { type: 'TASK_OVERDUE', label: 'Task Overdue' },
  { type: 'TASK_COMPLETED', label: 'Task Completed' },
  { type: 'STAGE_CHANGED', label: 'Stage Changed' },
  { type: 'COMPANY_ASSIGNED', label: 'Company Assigned' },
  { type: 'COMPANY_CREATED', label: 'Company Created' },
  { type: 'DOCUMENT_UPLOADED', label: 'Document Uploaded' },
  { type: 'MEETING_SCHEDULED', label: 'Meeting Scheduled' },
  { type: 'MEETING_REMINDER', label: 'Meeting Reminder' },
  { type: 'COMMENT_MENTION', label: 'Comment/Mention' },
  { type: 'TEAM_MEMBER_ADDED', label: 'Team Added' },
  { type: 'EMAIL_SENT', label: 'Email Sent' },
  { type: 'GENERAL', label: 'General' }
];
